let locales = {
    parametizableText_routes: 'Rutas',
    parametizableText_validatorUris:'Esta opción ya ha sido seleccionada',
};
export default locales;